import { ITenantConcernCategoryHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useTenantConcernCategories = (id: number | string | undefined): ITenantConcernCategoryHook => {
  const { concernStore } = useStore();
  const { tenantConcernCategories } = concernStore;

  useEffect(() => {
    id && concernStore.getAllByTenantId({ id: Number(id) });
  }, [concernStore, id]);

  return { tenantConcernCategories };
};
